type QuoteDashboardIconProps = {
  className?: string;
};

export const QuoteDashboardIcon = ({
  className,
}: QuoteDashboardIconProps): React.ReactElement => (
  <svg
    id="dashboard-off"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 15.779 21.748"
  >
    <g id="menu">
      <g id="icon_orders">
        <path
          id="Path_215"
          data-name="Path 215"
          d="M20.449,5.206h-2.87a.7.7,0,0,1-.657-.726V1.469H7.334c.006,0,0,.011,0,.03V18.237l1.381,1.647,2.057-2.453a.624.624,0,0,1,.976,0l2.135,2.546,2.135-2.546a.624.624,0,0,1,.976,0l2.14,2.551,1.317-1.543Zm-2.213-3.06V3.753H19.7ZM18.03,12.409a.73.73,0,0,1,0,1.453H9.594a.73.73,0,0,1,0-1.453Zm0-2.815a.73.73,0,0,1,0,1.453H9.594a.73.73,0,0,1,0-1.453ZM14.28,6.78a.73.73,0,0,1,0,1.453H9.594a.73.73,0,0,1,0-1.453ZM6,18.537V1.5A1.427,1.427,0,0,1,7.334,0h10.38a1.034,1.034,0,0,1,.854.437l2.815,3.1a1.394,1.394,0,0,1,.4.991v14.2a.777.777,0,0,1-.181.5l-1.987,2.278a.623.623,0,0,1-.972,0l-2.135-2.5-2.135,2.5a.624.624,0,0,1-.976,0l-2.135-2.5L9.2,21.513a.624.624,0,0,1-.976,0l-1.974-2.4A.764.764,0,0,1,6,18.537Z"
          transform="translate(-6 0)"
        />
      </g>
    </g>
  </svg>
);
